// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b8b27ee","city":"_780e9b4"};